import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatsAndReportsModule } from '../stats-and-reports/stats-and-reports.module';
import { DashboardRoutingModule } from './/dashboard-routing.module';
import { DashboardShellComponent } from './dashboard-shell/dashboard-shell.component';

@NgModule({
  imports: [CommonModule, StatsAndReportsModule, DashboardRoutingModule],
  declarations: [DashboardShellComponent],
})
export class DashboardModule {}
